import React from "react";
import { Icon } from "@telia/teddy";
import cn from "classnames";
import TEXT from "../../../text-consts";
import "./GeoLocation.less";

interface GeoLocationProps {
    className: string;
    error: PositionErrorCallback;
    onClick: () => void;
    onNotAvailable: () => void;
    options?: PositionOptions;
    success: PositionCallback;
}

const GeoLocation: React.FC<GeoLocationProps> = ({
    options = {
        enableHighAccuracy: true,
        timeout: 60000,
        maximumAge: 60000,
    },
    onClick,
    onNotAvailable,
    success,
    error,
    className,
}) => {
    const onClickHandler = () => {
        onClick();
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success, error, options);
        } else {
            onNotAvailable();
        }
    };

    return (
        <button onClick={onClickHandler} className={cn("geolocation", { [className]: className })}>
            <Icon className="geolocation__icon" name="map" />
            <span>{TEXT.NEARBY}</span>
        </button>
    );
};

export default GeoLocation;
